import React from 'react';
import { Carousel } from '@mantine/carousel';
import TestimonyItem from './TestimonyItem';
import styles from './styles.module.scss';
import { useMediaQuery } from '@mantine/hooks';
import { ContentSectionDetail } from '../ContentSection';

interface TestimonyCarouselProps {
  data: ContentSectionDetail[];
  isSearch?: boolean;
  isCarousel?: 'Y' | 'N' | null;
  isHomepage?: boolean;
  title: string;
}
const TestimonyCarousel: React.FC<TestimonyCarouselProps> = ({
  data,
  isSearch,
  title,
  isHomepage,
  isCarousel
}) => {
  const xsScreen = useMediaQuery('(max-width: 30em)');
  const smScreen = useMediaQuery('(max-width: 48em)');
  const mdScreen = useMediaQuery('(max-width: 64em)');
  const lgScreen = useMediaQuery('(max-width: 74em)');
  const size =
    smScreen || mdScreen
      ? (100 / 2).toString()
      : lgScreen
      ? (100 / 3).toString()
      : (100 / 4).toString();
  const slidesScroll = xsScreen ? 1 : smScreen || mdScreen ? 2 : 4;

  return (
    <>
      <Carousel
        withIndicators
        classNames={styles}
        loop
        align="start"
        slideSize={{ base: '100%', sm: size + '%' }}
        slideGap={{ base: 0, sm: smScreen || mdScreen ? 'sm' : 'lg' }}
        slidesToScroll={slidesScroll}
        py={12}
        mb={10}
      >
        {data.map((item: ContentSectionDetail, index: number) => {
          return (
            <Carousel.Slide key={index}>
              <TestimonyItem
                {...item}
                isCarousel={isCarousel}
                title={title}
                isSearch={isSearch}
              />
            </Carousel.Slide>
          );
        })}
      </Carousel>
    </>
  );
};

export default TestimonyCarousel;
